<section class="row makePaymentView" id="productList-area">
  <aside class="col-md-3 col-sm-3 col-lg-2 col-xs-12 applied-filter pr-0">
    <fieldset class="orderstatus-style">
      <div class="filterByGroup">
        <div class="filterByTitle">
          <label for="invoice">{{
            "ordersList.orderStatus" | cxTranslate
            }}</label>
          <div>
            <ng-select name="orderstatus" [items]="orderStatusList" [searchable]="false" [clearable]="false"
              bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)"
              [(ngModel)]="orderStatus"></ng-select>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset id="filter-by">
      <legend class="filterByTitle-main order-history-search">
        {{ "ordersList.searchBy" | cxTranslate }}
      </legend>
      <div class="grey-line"></div>
      <div class="filterByGroup mb-3">
        <div class="filterByTitle">
          <label for="invoice">{{
            "ordersList.timeFrame" | cxTranslate
            }}</label>
        </div>
        <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false" bindLabel="name"
          bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()" [(ngModel)]="timeFrame">
        </ng-select>
      </div>

      <!--Date Range-->
      <div class="filterByGroup">
        <div class="filterByTitle mb-2">
          {{ "ordersList.dateRange" | cxTranslate }}
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="fromDate" aria-labelledby="dataRange fromDate">{{
                  "ordersList.from" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" readonly placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}"
                    class="input-filter" [(ngModel)]="fromDate" (ngModelChange)="validateDate()" bsDatepicker
                    [maxDate]="maxSelectionDate" [minDate]="minSelectionDate" [bsConfig]="{
                      containerClass: 'order-list-date',
                      dateInputFormat: 'MM/DD/YYYY'
                    }" />
                </label>
                <!-- <span class="dateError" *ngIf="!fromDate && toDate">Please enter from date</span> -->
              </div>
            </fieldset>
          </div>
        </div>
        <div class="delivary-details">
          <div>
            <fieldset class="form-horizontal mb0">
              <legend class="control-group mb-2">
                <label for="toDate" aria-labelledby="dataRange toDate">{{
                  "ordersList.to" | cxTranslate
                  }}</label>
              </legend>
              <div class="headSearch-holder">
                <label class="searchbox orders-filter time-frame">
                  <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                  <input type="text" readonly placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}"
                    class="input-filter" [(ngModel)]="toDate" (ngModelChange)="validateDate()" bsDatepicker
                    [maxDate]="maxSelectionDate" [minDate]="minSelectionDate" [bsConfig]="{
                      containerClass: 'order-list-date',
                      dateInputFormat: 'MM/DD/YYYY'
                    }" />
                </label>
                <!-- <span class="dateError" *ngIf="fromDate && !toDate">Please enter to date</span> -->
              </div>
            </fieldset>
          </div>
        </div>
        <span class="dateError" *ngIf="dateError">{{
          "ordersList.invalidDateErrMsg" | cxTranslate
          }}</span>
        <span class="dateError" *ngIf="singleDateError">{{
          "ordersList.selectBothDate" | cxTranslate
          }}</span>
      </div>
      <!--End-->

      <div class="filterByGroup">
        <div class="filterByTitle mb-2">
          <label for="invoice">{{ "ordersList.invoice" | cxTranslate }}</label>
        </div>
        <div class="headSearch-holder">
          <div class="searchbox orders-filter time-frame">
            <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
              aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="invoice"
              (paste)="onKeyPress($event.target.value)" (keyup)="onKeyPress($event.target.value)" />
            <button role="presentation" class="search-icon">
              <span class="searchicon">
                <img (click)="applyFilter()" src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
              </span>
            </button>
          </div>
        </div>

        <div class="filterByTitle mb-2">
          <label for="poNumber">{{ "ordersList.po" | cxTranslate }}</label>
        </div>
        <div class="headSearch-holder">
          <div class="searchbox orders-filter time-frame">
            <input placeholder="Search" type="text" maxlength="35" autocomplete="off"
              aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
              class="input-filter" [(ngModel)]="poNumber" (paste)="onKeyPress($event.target.value)"
              (keyup)="onKeyPress($event.target.value)" />
            <button role="presentation" class="search-icon">
              <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
              <span class="searchicon">
                <img (click)="applyFilter()" src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
              </span>
            </button>
          </div>
        </div>

        <div class="filterByTitle mb-2">
          <label for="orderNumber">{{
            "ordersList.order" | cxTranslate
            }}</label>
        </div>
        <div class="headSearch-holder">
          <div class="searchbox orders-filter time-frame">
            <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
              aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="order"
              (paste)="onKeyPress($event.target.value)" (keyup)="onKeyPress($event.target.value)" />
            <button role="presentation" class="search-icon">
              <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
              <span class="searchicon">
                <img (click)="applyFilter()" src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
              </span>
            </button>
          </div>
        </div>

        <div class="filterByTitle mb-2">
          <label for="orderNumber">{{
            "ordersList.product" | cxTranslate
            }}</label>
        </div>

        <div class="headSearch-holder">
          <app-product-search (selectedProductEvent)="getSelectedProduct($event)" [clearSearchValue]="!!!product">
          </app-product-search>
          <!-- <div class="searchbox orders-filter time-frame">
            <input placeholder="Search product catalog" type="text" autocomplete="off"
              aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
              class="input-filter" [(ngModel)]="product" (paste)="onKeyPress($event.target.value)"
                        (keyup)="onKeyPress($event.target.value)" />
            <button role="presentation" class="search-icon">
              <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
              <span class="searchicon"></span>
            </button>
          </div> -->
        </div>
      </div>
      <div class="account-order-filter-btn">
        <button type="submit" class="btn-primary padding-20 w-100" data-di-id="di-id-362f2c77-5f23e741"
          [ngClass]="(!isFilterSelected || dateError)? 'disable-btn' : 'enable-btn'" (click)="applyFilter()">
          {{ "ordersList.applyFilters" | cxTranslate }}
        </button>
        <button type="button" id="clearOrderFiltersBtn" class="btn btn-default white-button"
          data-di-id="#clearOrderFiltersBtn" (click)="clearFilters()">
          {{ "ordersList.clearFilters" | cxTranslate }}
        </button>
      </div>
    </fieldset>
    <div class="line-intersection"></div>
    <section>
      <div>
        <app-need-to-go-back></app-need-to-go-back>
      </div>
      <div class="line-intersection"></div>
    </section>
    <section>
      <div>
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section>
  </aside>
  <section class="col-md-9 col-sm-9 col-lg-10 table-s-section float-right">
    <section class="filter-section">
      <section class="row">
        <section class="col-sm-12 col-md-12 col-md-12 col-xs-12 op_ovice">
          <div id="filter-applied" class="applied-filter">
            <!-- <div class="row row-20 page-section">
                            <div class="col-md-7 col-sm-6 hidden-xs filterApply-showing">
                                <span>{{ "ordersList.showing" | cxTranslate }} {{ end }}
                                    {{ "ordersList.of" | cxTranslate }}
                                    {{ totalOrders }}
                                    {{ "ordersList.orders" | cxTranslate }}</span>
                            </div>
                            <div class="col-md-5 col-sm-6 top-pagination left-pagination">
                                <div class="time-frame">
                                    <span class="top-page-id mr-2 pt-1" id="accPageInfo">{{ "ordersList.page" |
                                        cxTranslate }} {{ curPage
                                        }}
                                        {{ "ordersList.of" | cxTranslate }}
                                        {{ numberOfPages() }}</span>
                                    <div class="pagination">
                                        <button [disabled]="curPage == 1" (click)="getCurrentPage('prev')"
                                            (click)="getOrderList()" class="pagination-btns mr-1">
                                            <span class="chevronIconWhite prev"></span>
                                        </button>

                                        <button class="pagination-btns" [disabled]="
                        curPage >= totalOrders / pageSize ||
                        (totalOrders === 0 && pageSize === 0)
                      " (click)="getCurrentPage('next')" (click)="getOrderList()">
                                            <span class="chevronIconWhite next"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="hidden-xs" /> -->
            <div class="row row-20" [ngClass]="facetsList.length > 2 ? 'page-dropdown-ipad' : ''">
              <div class="col-12 hidden-xs applied-filters">
                {{ "ordersList.filtersApplied" | cxTranslate }}
                <span *ngIf="!facetsList.length">{{
                  "ordersList.none" | cxTranslate
                  }}</span>
                <span id="applied-filters" class="ml-2">
                  <span class="filterText focus mr-1 mb-2" tabindex="0" *ngFor="let filter of facetsList">
                    <div>
                      {{ convertToPlain(filter.value)
                      }}<img src="../../../assets/icons/close_w.png" alt="" class="remove-facet"
                        (click)="removeFacet(filter)" />
                      <span class="filterRemove"></span>
                    </div>
                  </span><a class="clear-filters ml-1" (click)="clearFilters()" *ngIf="facetsList.length">{{
                    "ordersList.clearAllFilters" | cxTranslate }}</a>
                </span>
              </div>
              <!-- <div class="col-md-4 col-sm-5 col-xs-12 sortBy-select px-12">
                                <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false"
                                    bindLabel="name" bindValue="code" class="set-pagination"
                                    [(ngModel)]="pageSizeperPage" (change)="changePageSize()" (change)="applyFilter()">
                                </ng-select>
                            </div>  -->
            </div>
          </div>
        </section>
      </section>
    </section>

    <section class="payment-section filter-section">
      <section class="dispaly-refine">
        <ng-template #facetsRwd class="select-refine">
          <section class="modal-class">
            <section class="modal-heading">
              <h2>
                <span class="close-icon" aria-hidden="true" (click)="hide()">&times;</span>
              </h2>
              <h2 class="select-heading">
                {{ "plp.selectRefinement" | cxTranslate }}
              </h2>
            </section>
            <section>
              <fieldset class="orderstatus-style">
                <div class="filterByGroup">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.orderStatus" | cxTranslate
                      }}</label>
                    <div>
                      <ng-select name="orderstatus" [items]="orderStatusList" [searchable]="false" [clearable]="false"
                        bindLabel="name" bindValue="code" class="dropdown-credit" (change)="onKeyPress($event)"
                        [(ngModel)]="orderStatus"></ng-select>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset id="filter-by">
                <legend class="filterByTitle-main order-history-search">
                  {{ "ordersList.searchBy" | cxTranslate }}
                </legend>
                <div class="grey-line"></div>
                <div class="filterByGroup mb-3">
                  <div class="filterByTitle">
                    <label for="invoice">{{
                      "ordersList.timeFrame" | cxTranslate
                      }}</label>
                  </div>
                  <ng-select name="timeFrame" [items]="timeFrameList" [searchable]="false" [clearable]="false"
                    bindLabel="name" bindValue="code" class="dropdown-credit" (ngModelChange)="clearDateRange()"
                    [(ngModel)]="timeFrame">
                  </ng-select>
                </div>

                <!--Date Range-->
                <div class="filterByGroup">
                  <div class="filterByTitle mb-2">
                    {{ "ordersList.dateRange" | cxTranslate }}
                  </div>
                  <div class="delivary-details">
                    <div>
                      <fieldset class="form-horizontal mb0">
                        <legend class="control-group mb-2">
                          <label for="fromDate" aria-labelledby="dataRange fromDate">{{
                            "ordersList.from" | cxTranslate
                            }}</label>
                        </legend>
                        <div class="headSearch-holder">
                          <label class="searchbox orders-filter time-frame">
                            <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                            <input type="text" readonly placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}"
                              class="input-filter" [(ngModel)]="fromDate" (ngModelChange)="validateDate()" bsDatepicker
                              [maxDate]="maxSelectionDate" [minDate]="minSelectionDate" [bsConfig]="{
                                containerClass: 'order-list-date',
                                dateInputFormat: 'MM/DD/YYYY'
                              }" />
                          </label>
                          <!-- <span class="dateError" *ngIf="!fromDate && toDate">Please enter from date</span> -->
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="delivary-details">
                    <div>
                      <fieldset class="form-horizontal mb0">
                        <legend class="control-group mb-2">
                          <label for="toDate" aria-labelledby="dataRange toDate">{{
                            "ordersList.to" | cxTranslate
                            }}</label>
                        </legend>
                        <div class="headSearch-holder">
                          <label class="searchbox orders-filter time-frame">
                            <img src="../../../assets/icons/{{baseSiteId}}/calendar.svg" alt="" />
                            <input type="text" readonly placeholder="{{ 'ordersList.dateFormat' | cxTranslate }}"
                              class="input-filter" [(ngModel)]="toDate" (ngModelChange)="validateDate()" bsDatepicker
                              [maxDate]="maxSelectionDate" [minDate]="minSelectionDate" [bsConfig]="{
                                containerClass: 'order-list-date',
                                dateInputFormat: 'MM/DD/YYYY'
                              }" />
                          </label>
                          <!-- <span class="dateError" *ngIf="fromDate && !toDate">Please enter to date</span> -->
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <span class="dateError" *ngIf="dateError">{{
                    "ordersList.invalidDateErrMsg" | cxTranslate
                    }}</span>
                  <span class="dateError" *ngIf="singleDateError">{{
                    "ordersList.selectBothDate" | cxTranslate
                    }}</span>
                </div>
                <!--End-->

                <div class="filterByGroup">
                  <div class="filterByTitle mb-2">
                    <label for="invoice">{{ "ordersList.invoice" | cxTranslate }}</label>
                  </div>
                  <div class="headSearch-holder">
                    <div class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                        aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="invoice"
                        (paste)="onKeyPress($event.target.value)" (keyup)="onKeyPress($event.target.value)" />
                      <button role="presentation" class="search-icon">
                        <span class="searchicon">
                          <img (click)="applyFilter('mobile')"
                            src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
                        </span>
                      </button>
                    </div>
                  </div>

                  <div class="filterByTitle mb-2">
                    <label for="poNumber">{{ "ordersList.po" | cxTranslate }}</label>
                  </div>
                  <div class="headSearch-holder">
                    <div class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" maxlength="35" autocomplete="off"
                        aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
                        class="input-filter" [(ngModel)]="poNumber" (paste)="onKeyPress($event.target.value)"
                        (keyup)="onKeyPress($event.target.value)" />
                      <button role="presentation" class="search-icon">
                        <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
                        <span class="searchicon">
                          <img (click)="applyFilter('mobile')"
                            src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
                        </span>
                      </button>
                    </div>
                  </div>

                  <div class="filterByTitle mb-2">
                    <label for="orderNumber">{{
                      "ordersList.order" | cxTranslate
                      }}</label>
                  </div>
                  <div class="headSearch-holder">
                    <div class="searchbox orders-filter time-frame">
                      <input placeholder="Search" type="text" autocomplete="off" aria-describedby="initialDescription"
                        aria-controls="results" aria-autocomplete="both" class="input-filter" [(ngModel)]="order"
                        (paste)="onKeyPress($event.target.value)" (keyup)="onKeyPress($event.target.value)" />
                      <button role="presentation" class="search-icon">
                        <!-- <cx-icon [type]="iconTypes.SEARCH"></cx-icon> -->
                        <span class="searchicon">
                          <img (click)="applyFilter('mobile')"
                            src="../../../assets/icons/{{baseSiteId}}/search_new.svg">
                        </span>
                      </button>
                    </div>
                  </div>

                  <div class="filterByTitle mb-2">
                    <label for="orderNumber">{{
                      "ordersList.product" | cxTranslate
                      }}</label>
                  </div>

                  <div class="headSearch-holder">
                    <app-product-search (selectedProductEvent)="getSelectedProduct($event)"
                      [clearSearchValue]="!!!product">
                    </app-product-search>
                  </div>
                </div>
                <div class="account-order-filter-btn">
                  <button type="submit" class="btn-primary padding-20 w-100" data-di-id="di-id-362f2c77-5f23e741"
                    [ngClass]="(!isFilterSelected || dateError)? 'disable-btn' : 'enable-btn'"
                    (click)="applyFilter('mobile')">
                    {{ "ordersList.applyFilters" | cxTranslate }}
                  </button>
                  <button type="button" id="clearOrderFiltersBtn" class="btn btn-default white-button"
                    data-di-id="#clearOrderFiltersBtn" (click)="clearFilters('mobile')">
                    {{ "ordersList.clearFilters" | cxTranslate }}
                  </button>
                </div>
              </fieldset>
            </section>
            <!-- <footer class="p-2 input-search">
                            <button class="btn btn-default blue-button" (click)="applyFilter('mobile')">
                {{ "ordersList.done" | cxTranslate }}
              </button>
                        </footer> -->
          </section>
        </ng-template>
        <div class="account-order-filter-btn mb-1">
          <button class="btn btn-default white-button" data-di-id="#refineBtn" (click)="refine()">
            {{ "ordersList.refine" | cxTranslate }}
          </button>
        </div>
        <div class="sortBy-select pb-4 mobile-view-select">
          <ng-select name="pageSize" [items]="pageList" [searchable]="false" [clearable]="false" bindLabel="name"
            bindValue="code" class="dropdown-credit set-pagination" [(ngModel)]="pageSizeperPage"
            (change)="changePageSize()" (change)="applyFilter()"></ng-select>
        </div>
      </section>
      <section class="row pb-4">
        <div class="col-md-8 col-xs-6">
          <span class="order-history-table" *ngIf="timeFrame == 'Select'">{{ "ordersList.past" | cxTranslate }}&nbsp;{{
            dataTo }}</span>
          <span class="order-history-table" *ngIf="timeFrame != 'Select'"> PAST&nbsp;{{timeFrame}}</span>
        </div>
        <div class="col-md-4 col-xs-6 ad-files-text">
          <a aria-label="download order history as" id="orderXLS" (click)="generateSaveXls()">
            <img src="../../../assets/icons/{{baseSiteId}}/excel_new.png" alt="pdf" class="p-0 ad-pdf xls-img" />
            <span></span>
            <span class="pdf-text pl-1">{{
              "ordersList.xls" | cxTranslate
              }}</span>
          </a>
          <a aria-label="download order history as" id="orderPDF" (click)="generateSavePdf()">
            <img src="../../assets/icons/{{baseSiteId}}/pdf.svg" alt="pdf" class="ad-pdf" />
            <span class="ad-pdf"></span>
            <span class="pdf-text pdf-text-align">{{
              "ordersList.pdf" | cxTranslate
              }}</span>
          </a>
        </div>
      </section>
      <table aria-describedby="invoicesTable" #historicalOrdersTable id="ordersTable"
        class="order-list-table table table-striped">
        <thead>
          <tr>
            <th scope="col" (click)="sortColumn($event, 'placed', orders, 'Date')" class="date-title">
              {{ "ordersList.date" | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="type-title" (click)="sortColumn($event, 'sapSystemType', orders, 'normal')">
              {{ "ordersList.type" | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" (click)="sortColumn($event, 'code', orders, 'normal')" class="order-title">
              {{ "ordersList.order" | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" (click)="sortColumn($event, 'statusDisplay', orders, 'normal')" class="status-title">
              {{ "ordersList.status" | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="po-title" (click)="
                sortColumn($event, 'purchaseOrderNumber', orders, 'normal')
              ">
              {{ "ordersList.po" | cxTranslate }} &nbsp;
              <i class="my-icon fas fa-caret-down"></i>
            </th>
            <th scope="col" class="invoice-title">
              {{ "ordersList.invoice" | cxTranslate }}
            </th>
            <th scope="col" class="invoice-title" *ngIf="isAsmUser">
              {{ "ordersList.emailFax" | cxTranslate }}
            </th>
            <th scope="col" class="invoice-title" *ngIf="orderFullResults?.showPackingSlip">
              {{ "ordersList.packingSlip" | cxTranslate }}*
            </th>
            <th scope="col" class="tracking-title">
              {{ "ordersList.tracking" | cxTranslate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="totalOrders">
          <tr *ngFor="let data of ordersList; let i = index">
            <td>
              <span>{{ data.placedDate | date: "MM/dd/yyyy" }}</span>
            </td>
            <td>
              <span>{{ data.sapSystemType }}</span>
            </td>
            <td>
              <a [routerLink]="['/my-account/order', data?.code]" (click)="preserveTabState()"
                href="javascript: void(0);" *ngIf="data.statusDisplay!='Cancelled';else cancelledOrder">
                {{ data.code }}
              </a>
              <ng-template #cancelledOrder>
                {{ data.code }}
              </ng-template>
            </td>
            <td>{{ data.statusDisplay }}</td>
            <td>{{ data.purchaseOrderNumber }}</td>
            <td>
              <div *ngFor="let invoice of data.invoices">
                <span *ngIf="asmStringCheck(invoice.invoiceNumber); else notAsmUser">
                  {{invoice.invoiceNumber}}</span>
                <ng-template #notAsmUser>
                  <a (click)="generateInvoicePDF(invoice?.encryptedInvoiceNumber)" class="pdf-text">
                    {{invoice.invoiceNumber }}</a>
                </ng-template>
              </div>
            </td>
            <td class="text-center align-middle" *ngIf="isAsmUser">
              <div *ngFor="let invoice of data?.invoices; let j = index" class="asm-p2">
                <input type="checkbox" class="checkbox-asm" *ngIf="invoice?.invoiceNumber" (change)="
                    captureInvoiceForMail($event, invoice?.invoiceNumber, j)
                  " [id]="j + '_checkbox_' + invoice?.invoiceNumber"
                  [checked]="getCheckBoxStatus(j, invoice?.invoiceNumber)" />
              </div>
            </td>
            <td *ngIf="orderFullResults?.showPackingSlip">
              <div *ngFor="let packingSlip of data?.packingSlips">
                <a (click)="downloadPackingSlipPdf(packingSlip)" class="app-navigation-links">
                  View
                </a>
              </div>
            </td>
            <td>
              <div *ngFor="let tracking of data.tracking">
                <!--<a
                  *ngIf="tracking?.carrier !== 'YB'"
                  class="pdf-text app-navigation-links"
                  href="unsafe:javascript:void(0)"
                  rel="{{ tracking.trackingURL }}"
                  type="external"
                  >{{ tracking?.trackingNumber }}</a
                >-->
                <a class="invoice-number tracking-link" (click)="
                    goTovendorSite(
                      tracking?.trackingNumber,
                      tracking?.trackingURL
                    )
                  ">{{ tracking?.trackingNumber }}</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <section class="orders-table-orders">
        <div class="row orders-row-table" *ngFor="let data of orders; let i = index">
          <ul>
            <li>
              <p>
                <b>{{ "ordersList.date" | cxTranslate }}</b>
              </p>
              <p>
                {{ data.placedDate | date: "dd/MM/yyyy" }}
              </p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.type" | cxTranslate }}
                </b>
              </p>
              <p>{{ data.sapSystemType }}</p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.order" | cxTranslate }}
                </b>
              </p>
              <p>
                <a [routerLink]="['/my-account/order', data?.code]" (click)="preserveTabState()"
                  href="javascript: void(0);" *ngIf="data.statusDisplay!='Cancelled';else cancelledOrderRWD">
                  {{ data.code }}
                </a>
                <ng-template #cancelledOrderRWD>
                  {{ data.code }}
                </ng-template>
              </p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.status" | cxTranslate }}
                </b>
              </p>
              <p>{{ data.statusDisplay }}</p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.po" | cxTranslate }}
                </b>
              </p>
              <p>
                {{ data.purchaseOrderNumber }}
              </p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.invoice" | cxTranslate }}
                </b>
              </p>
              <p>
                <span *ngFor="let invoice of data.invoices">
                  <span class="d-block" *ngIf="asmStringCheck(invoice.invoiceNumber); else notAsmUser">
                    {{invoice.invoiceNumber}}</span>
                  <ng-template #notAsmUser>
                    <a (click)="generateInvoicePDF(invoice?.encryptedInvoiceNumber)" class="pdf-text d-block">
                      {{invoice.invoiceNumber }}</a>
                  </ng-template>
                </span>
              </p>
            </li>
            <li *ngIf="isAsmUser">
              <p>
                {{ "ordersList.emailFax" | cxTranslate }}
              </p>
              <p>
                <span *ngFor="let invoice of data?.invoices; let j = index" class="asm-p2 d-block">
                  <input type="checkbox" class="checkbox-asm" *ngIf="invoice?.invoiceNumber" (change)="
                    captureInvoiceForMail($event, invoice?.invoiceNumber, j)
                  " [id]="j + '_checkbox_' + invoice?.invoiceNumber"
                    [checked]="getCheckBoxStatus(j, invoice?.invoiceNumber)" />
                </span>
              </p>
            </li>
            <li *ngIf="orderFullResults?.showPackingSlip">
              <p>
                <b>
                  {{ "ordersList.packingSlip" | cxTranslate }}
                </b>
              </p>
              <p>
                <span *ngFor="let packingSlip of data?.packingSlips">
                  <a (click)="downloadPackingSlipPdf(packingSlip)" class="app-navigation-links d-block">
                    View
                  </a>
                </span>
              </p>
            </li>
            <li>
              <p>
                <b>
                  {{ "ordersList.tracking" | cxTranslate }}
                </b>
              </p>
              <p>
                <span *ngFor="let tracking of data.tracking">
                  <a class="invoice-number tracking-link d-block" (click)="
                  goTovendorSite(
                    tracking?.trackingNumber,
                    tracking?.trackingURL
                  )
                ">{{ tracking?.trackingNumber }}</a>
                </span>
              </p>
            </li>
          </ul>
        </div>
      </section>

      <div *ngIf="!totalOrders" class="empty-list">
        {{ "ordersList.noOrders" | cxTranslate }}
      </div>
      <div *ngIf="isAsmUser && invoicesListForMailASm?.length > 0" class="change-request-btngrps">
        <button type="button" class="btn btn-primary mr-4" [disabled]="invoicesListForMailASm?.length > 10"
          (click)="openFaxEmailPopup()">
          {{ "ordersList.sendEmailFax" | cxTranslate }}
        </button>
      </div>
      <div *ngIf="isAsmUser && invoicesListForMailASm?.length > 10" class="mr-5 defaulterrormsg change-request-btngrps">
        {{ "ordersList.emailFaxMaxInvoices" | cxTranslate }}
      </div>
    </section>
    <section>
      <span class="notifyTxtView">*Packing slip documents only include items that are shipped from Sanofi
        Pasteur</span>
    </section>
    <!-- <section>
            <div id="prod-pagination">
                <p>
                    {{ "ordersList.showing" | cxTranslate }} &nbsp;
                    <span class="no_rec">{{ end }}</span>&nbsp; {{ "ordersList.of" | cxTranslate }} &nbsp;
                    <span class="no_rec">{{ totalOrders }}</span>&nbsp; {{ "ordersList.orders" | cxTranslate }}
                </p>
                <p class="pagination align-btns">
                    <button [disabled]="curPage == 1" (click)="getCurrentPage('prev')" (click)="getOrderList()"
                        class="pagination-btns mr-1">
                        <span class="chevronIconWhite prev"></span>
                    </button>

                    <button class="pagination-btns" [disabled]="
              curPage >= totalOrders / pageSize ||
              (totalOrders === 0 && pageSize === 0)
            " (click)="getCurrentPage('next')" (click)="getOrderList()">
                        <span class="chevronIconWhite next"></span>
                    </button>
                </p>
                <p>
                    <span>{{ "ordersList.page" | cxTranslate }} {{ curPage }}
                        {{ "ordersList.of" | cxTranslate }} {{ numberOfPages() }}</span>
                </p>
            </div>
        </section> -->

    <div class="line-intersection mobile-view"></div>
    <section class="mobile-view">
      <div>
        <app-need-to-go-back></app-need-to-go-back>
      </div>
      <div class="line-intersection"></div>
    </section>
    <section class="mobile-view">
      <div class="banner-img">
        <app-flu-dashboard-banner bannerComponent="OrderHistoryBannerComponent"></app-flu-dashboard-banner>
      </div>
    </section>
  </section>
</section>